module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Spam-9f0452970fd75e2b993389f6fe657575.svg";